export const API_URL = "https://back.hijomauzb.uz";
